import { createContext } from 'react'

export const AssetContext = createContext(null)
